import { buildStyledComponent } from 'decisiv-ui-utils';
import styled from 'styled-components';

const styles = `
  padding: 0;
  margin: 0;
  list-decoration: none;
`;

export default buildStyledComponent(
  'ScrollableContainer.List',
  styled.ul,
  styles,
);



// WEBPACK FOOTER //
// ./elements/ScrollableContainer/List.js